<template>
  <div :id="outerId" class="clearfix" :style="{ minHeight: minHeight + 'px', width: '100%' }">
    <div :id="chartId" :style="{ minHeight: minHeight + 'px', width: '100%' }">

    </div>
  </div>
</template>
<script>
  import ChartMixin from './mixins/chart'
  export default {
    name: 'SimplePie',
    mixins: [ChartMixin],
    props: {
      chartData: {
        /*
        * Data must be in the structure: {
        * categoryField: 'val',
        * valueField: 'val',
        * }
        * where categoryField will equal this.props.categoryField --> x axis
        * where valueField will equal this.props.valueField --> y axis
        */
        type: Array,
        required: true
      },
      categoryField: {
        type: String,
        required: true
      },
      valueField: {
        type: String,
        required: true
      }
    },
    methods: {
      init (data) {
        this.chart = window.AmCharts.makeChart(this.chartId, {
          type: 'pie',
          theme: 'light',
          dataProvider: this.chartData,
          valueField: this.valueField,
          titleField: this.categoryField,
          balloon: {
            fixedPosition: true
          },
          export: {
            enabled: true
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/charts/SimplePie.vue